export const hmapPathParamRegex = "{hmapPath:[0-9-]*}";
export const hmapPathParamConfig = {
    hmapPath: {value: '', squash: true}
}
export var HMAPRoutes = {
    "/access-portal": {
        "name": "appLayout.harriSH.access-portal",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "templateUrl": "../modules/hmap/access-portal-layout/access-portal-layout.html",
        "abstract": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hmap_dashboard"]
        },
        "resolve": {
            clearUserContext: ['hUser', '$stateParams', '$transition$', '$location', async (hUser, $stateParams, $transition$, $location) => {
                if ($transition$.from().name.indexOf("appLayout.harriSH.access-portal") === -1) {
                    hUser.clearUserContext();
                }
                return true;
            }],
        },
        "onEnter": ['$transition$', '$location', function ($transition$, $location) {
            if ($transition$.to().name === 'appLayout.harriSH.access-portal.main') {
                $location.search('gid', null);
            }
        }],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/hyper-hire/hyperhire.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/holidays-and-absences/holidays-and-absences.module.js');
                }
            }
        ],
    },
    [`/main/${hmapPathParamRegex}`]: {
        "name": "appLayout.harriSH.access-portal.main",
        "templateUrl": "../modules/hmap/dashboard/hmap_dashboard.html",
        "controller": "HMAPDashboardController",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hmap_dashboard"]
        },
        "params": {
            ...hmapPathParamConfig
        }
    },
    [`/atrs-listings/${hmapPathParamRegex}`]: {
        "name": "appLayout.harriSH.access-portal.atrs-listings",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "onEnter": ['$state', '$stateParams', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, navigationService, useGPSettingsNav) {
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.atrs-listings',{
                    hmapPath: $stateParams['hmapPath']
                }))
                    .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                    })
                    .catch(console.error);
            }],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["authority_to_recruit", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/authority-to-recruit/authority-to-recruit.module.js");

                },
            },
        ],
        "controller": "HMAPAtrsListingsController",
        "templateUrl": "../modules/hmap/atrs_listings/hmap_atrs_listings.html"
    },
    [`/atrs-manage/${hmapPathParamRegex}?atr_id&brand_id`]: {
        "name": "appLayout.harriSH.access-portal.atrs-manage",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["authority_to_recruit"]
        },
        "params": {
            ...hmapPathParamConfig
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/authority-to-recruit/authority-to-recruit.module.js");

                },
            },
        ],
        "controller": "HMAPAtrsManageController",
        "templateUrl": "../modules/hmap/atrs_manage/hmap_atrs_manage.html"
    },
    [`/reports/${hmapPathParamRegex}`]: {
        "name": "appLayout.harriSH.access-portal.reports",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['hmap_raw_data_reporting', 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Reports"
            }
        ],
        "onEnter": ['$state', '$stateParams', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, navigationService, useGPSettingsNav) {
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.reports', {
                    hmapPath: $stateParams['hmapPath']
                }))
                    .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                    })
                    .catch(console.error);
            }],
        "controller": "HMAPRawDataReportingController",
        "templateUrl": "../modules/hmap/raw-data-reporting/hmap_raw-data-reporting.html"
    },
    "?gp": {
        "name": "appLayout.harriSH.access-portal.settings",
        "type": "frontend",
        "abstract": true,
        "showGlobalSearch": true,
        "loginRequired": true,
        "component": 'gpSettingsContainer',
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Settings"
            }
        ],
    },
    [`/settings/${hmapPathParamRegex}?activeTab&subTab`]: {
        "name": "appLayout.harriSH.access-portal.settings.main",
        "type": "frontend",
        "showSettingsHeader": true,
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Settings"
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["rejection_templates", "restricted_positions", "branded_comms", "pay_runs", "document_uploader", "custom_sources", "mice", "documents_default_fields", "auto_wage_matrix", "organization_settings", "enterprise_communication_settings", "blocked_terminated_employees", 'tl_reports_settings', 'abs-settings', 'work-visas', 'job-titles-management', 'live-shift-alerts', 'shared-hmap-teamlive-settings', 'notifications-management', 'centralized-settings', 'attendance_settings']
        },
        "component": "hmapSettingsPage",
        'resolve': {
            'settingsRedirection': ['$state', '$stateParams', '$location', 'useGPSettingsNav', 'useNavFactory', 'navigationService', async ($state, $stateParams, $location, useGPSettingsNav, useNavFactory, navigationService) => {
                if (!$stateParams.activeTab) {
                    const navFactory = useNavFactory();
                    return navFactory.init(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav)
                        .then(() => {
                            const item = navFactory.state.activeNavs[0][0].filteredSections[0].items[0];
                            Utils.goToUrl(item.href());
                        })
                        .catch(console.error);
                }
            }]
        },
        "onEnter": ['$state', '$stateParams', 'useGPSettingsNav', 'useNavFactory', 'navigationService', async ($state, $stateParams, useGPSettingsNav, useNavFactory, navigationService) => {
            if ($stateParams.activeTab) {
                return navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams.hmapPath).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.settings.main', {
                    activeTab: $stateParams['activeTab'],
                    hmapPath: $stateParams['hmapPath'],
                }))
                    .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                        }
                        return true;
                    })
                    .catch(console.error);
            }
        }],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./settings/hmap-settings.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/hyper-hire/hyperhire.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/attendance-settings/attendance-settings.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/blocked-terminated-employees/blocked-terminated-employees.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/auto-wage-matrix/auto-wage-matrix.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/background-checks/background-checks.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/restricted-positions/restricted-positions.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/ch-setting/ch-settings.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../modules/team_schedule/employer/reports/tl-reports-settings.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/branded-comms/branded-comms.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/pay-runs/pay-runs.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/job-approval/job-approval.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/mice/mice.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/holidays-and-absences/holidays-and-absences.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../modules/team_schedule/employer/benifits/employee-benefits.module.js')
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/schedule-approval-flow/schedule-approval-flow.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/activity-based-scheduling/activity-based-scheduling-settings.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/work-visas/work-visas.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/job-titles-management/job-titles-management.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/work-restrictions/work-restrictions.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/live-shift-alerts/live-shift-alerts.module.js')
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/shared-hmap-teamlive-settings/shared-hmap-teamlive-settings.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/notifications-management/notifications-management.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/minor-settings-management/minor-settings-management.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/custom-docs/custom-docs.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/offer-templates/offer-templates.module.js')
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/performance-second-approval/performance-second-approval.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/live-shift-view/live-shift-view.module.js')
                }
            },
        ]
    },
    "/recruitment-hub/jobs": {
        "name": "appLayout.harriSH.access-portal.jobs",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hmap_my_jobs"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Recruitment hub"
            }
        ],
        "component": "hmapMyJobsPage",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./my_jobs/hmap-my-jobs.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/job-approval/job-approval.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/talent-pool/talent-pool.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/recruitment-hub/recruitment-hub.module.js");
                }
            }
        ],
        "onEnter": ['$state', 'brandServices', 'hUser', function ($state, brandServices, hUser) {
            brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, hUser.getUserContext().brand_id)
                .then(function (isOnBoardingJourneyEnabled) {
                    if (isOnBoardingJourneyEnabled) {
                        if (hUser.isTopLevelContext()) {
                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                        } else {
                            $state.go("appLayout.harriSH.dashboard");
                        }
                    }
                })
                .catch(function (err) {
                    console.error(err);
                });
        }],
    },
    "/report-scheduler": {
        "name": "appLayout.harriSH.access-portal.report-scheduler",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "component": 'reportSchedulerContainer',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['hmap_raw_data_reporting', 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Report Scheduler"
            }
        ],
        "onEnter": ['$state', '$stateParams', 'useAnalyticsSettingsNav',
            async function ($state, $stateParams, useAnalyticsSettingsNav) {
                let isReportSchedulerVisible;
                try {
                    isReportSchedulerVisible = await useAnalyticsSettingsNav().isReportSchedulerVisible();
                } catch (e) {
                    console.error(e);
                }

                if (!isReportSchedulerVisible) {
                    $state.go('appLayout.harriSH.access-portal.main', {hmapPath: $stateParams.hmapPath});
                }
            }],
    },
    "/recruitment-hub/interview-schedule?date&job_id&job_pos_cat_code&bucket_id&app_id&single&brand_id&hide_images": {
        "name": "appLayout.harriSH.access-portal.interview-schedule",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            job_id: {dynamic: true},
            job_pos_cat_code: {dynamic: true},
            bucket_id: {dynamic: true},
            app_id: {dynamic: true},
            brand_id: {dynamic: true},
            single: {dynamic: true},
            hide_images: {dynamic: true}
        },
        "component": "hmapMyJobsPage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hmap_my_jobs", "interview_manifest"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Schedule"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/interview-scheduling/interview-scheduling.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/recruitment-hub/recruitment-hub.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/on-boarding/on-boarding.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/outmatch-assessment/outmatch-assessment.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/pos-integration/pos-integration.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/access-portal/my-applicants/my-applicants.module.js");
                }
            },
        ],
    },
    "/recruitment-hub/interview-availability": {
        "name": "appLayout.harriSH.access-portal.interview-availability",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "component": "hmapMyJobsPage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hmap_my_jobs", "interview_manifest"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Interview Schedule"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/interview-scheduling/interview-scheduling.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/recruitment-hub/recruitment-hub.module.js");
                }
            }
        ],
    },
    "/indeed-campaigns": {
        "name": "appLayout.harriSH.access-portal.indeed-campaigns",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hmap_my_jobs"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Indeed Campaigns"
            }
        ],
        "component": "hmapMyJobsPage",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./my_jobs/hmap-my-jobs.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/recruitment-hub/recruitment-hub.module.js");
                }
            }
        ]
    },
    "/view-indeed-campaign/:id": {
        "name": "appLayout.harriSH.access-portal.view-indeed-campaign",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hmap_my_jobs"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Indeed Campaigns"
            }
        ],
        "component": "hmapMyJobsPage",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./my_jobs/hmap-my-jobs.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/recruitment-hub/recruitment-hub.module.js");
                }
            }
        ]
    },
    "/create-campaign": {
        "name": "appLayout.harriSH.access-portal.create-campaign",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hmap_my_jobs"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Indeed Campaigns"
            }
        ],
        "component": "hmapMyJobsPage",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./my_jobs/hmap-my-jobs.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/recruitment-hub/recruitment-hub.module.js");
                }
            }
        ]
    },
};
